interface StripeLoadingInput {
	paymentsEnabled: boolean;
	stripeLinkedAccountId?: string | null;
	stripePublishableKey?: string | null;
}

export const canLoadStripe = ({
	paymentsEnabled,
	stripeLinkedAccountId,
	stripePublishableKey,
}: StripeLoadingInput) =>
	paymentsEnabled &&
	Boolean(stripeLinkedAccountId) &&
	Boolean(stripePublishableKey);

interface StripeContextInput {
	paymentsEnabled: boolean;
	stripeLinkedAccountId?: string | null;
	loadedStripeAccountId?: string | null;
}

export const isCurrentStripeContext = ({
	paymentsEnabled,
	stripeLinkedAccountId,
	loadedStripeAccountId,
}: StripeContextInput) =>
	paymentsEnabled &&
	Boolean(stripeLinkedAccountId) &&
	stripeLinkedAccountId === loadedStripeAccountId;
